import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Activity, TrendingUp, Heart } from 'lucide-react';
interface InvestorSlide1Props {
  isDark?: boolean;
}
export function InvestorSlide1({
  isDark = false
}: InvestorSlide1Props) {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.12,
        delayChildren: 0.1
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: [0.25, 0.1, 0.25, 1]
      }
    }
  };
  return <motion.div className="h-full w-full overflow-y-auto overflow-x-hidden" variants={containerVariants} initial="hidden" animate="visible" data-id="element-135">
      <div className="min-h-full flex flex-col justify-center max-w-6xl mx-auto px-6 sm:px-12 py-20 sm:py-24" data-id="element-136">
        <motion.div variants={itemVariants} className="mb-12 sm:mb-16 text-center" data-id="element-137">
          <h1 className={`text-3xl sm:text-5xl font-bold mb-6 sm:mb-8 tracking-tight ${isDark ? 'text-white' : 'text-heliona-charcoal'}`} data-id="element-138">
            Our Mission
          </h1>
          <p className={`text-xl sm:text-3xl max-w-4xl mx-auto leading-relaxed font-serif italic ${isDark ? 'text-white/90' : 'text-heliona-charcoal/90'}`} data-id="element-139">
            "Transform how organizations measure, develop, and support
            leadership health at scale."
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 sm:gap-12" data-id="element-140">
          {/* Pillar 1: Measure */}
          <motion.div variants={itemVariants} className={`rounded-3xl p-8 sm:p-10 text-center shadow-sm hover:shadow-md transition-all duration-300 ${isDark ? 'bg-white/[0.03] border border-white/10' : 'bg-gradient-to-br from-heliona-orange/10 to-heliona-orange/5 border border-heliona-orange/30'}`} data-id="element-141">
            <div className="w-16 h-16 sm:w-20 sm:h-20 rounded-2xl bg-heliona-orange/20 flex items-center justify-center mb-6 sm:mb-8 text-heliona-orange mx-auto border border-heliona-orange/30" data-id="element-142">
              <Activity className="w-8 h-8 sm:w-10 sm:h-10" data-id="element-143" />
            </div>
            <h3 className={`text-xl sm:text-2xl font-bold mb-3 sm:mb-4 ${isDark ? 'text-white' : 'text-heliona-charcoal'}`} data-id="element-144">
              Measure
            </h3>
            <p className={`text-base sm:text-lg leading-relaxed ${isDark ? 'text-white/70' : 'text-heliona-text-gray'}`} data-id="element-145">
              Data-driven insights into leadership capacity and strain
            </p>
          </motion.div>

          {/* Pillar 2: Develop */}
          <motion.div variants={itemVariants} className={`rounded-3xl p-8 sm:p-10 text-center shadow-sm hover:shadow-md transition-all duration-300 ${isDark ? 'bg-white/[0.03] border border-white/10' : 'bg-gradient-to-br from-heliona-mint/10 to-heliona-mint/5 border border-heliona-mint/30'}`} data-id="element-146">
            <div className="w-16 h-16 sm:w-20 sm:h-20 rounded-2xl bg-heliona-mint/20 flex items-center justify-center mb-6 sm:mb-8 text-heliona-mint-dark mx-auto border border-heliona-mint/30" data-id="element-147">
              <TrendingUp className="w-8 h-8 sm:w-10 sm:h-10" data-id="element-148" />
            </div>
            <h3 className={`text-xl sm:text-2xl font-bold mb-3 sm:mb-4 ${isDark ? 'text-white' : 'text-heliona-charcoal'}`} data-id="element-149">
              Develop
            </h3>
            <p className={`text-base sm:text-lg leading-relaxed ${isDark ? 'text-white/70' : 'text-heliona-text-gray'}`} data-id="element-150">
              Personalized growth paths for sustainable performance
            </p>
          </motion.div>

          {/* Pillar 3: Support */}
          <motion.div variants={itemVariants} className={`rounded-3xl p-8 sm:p-10 text-center shadow-sm hover:shadow-md transition-all duration-300 ${isDark ? 'bg-white/[0.03] border border-white/10' : 'bg-gradient-to-br from-heliona-navy/10 to-heliona-slate/5 border border-heliona-navy/30'}`} data-id="element-151">
            <div className="w-16 h-16 sm:w-20 sm:h-20 rounded-2xl bg-heliona-navy/20 flex items-center justify-center mb-6 sm:mb-8 text-heliona-navy mx-auto border border-heliona-navy/30" data-id="element-152">
              <Heart className="w-8 h-8 sm:w-10 sm:h-10" data-id="element-153" />
            </div>
            <h3 className={`text-xl sm:text-2xl font-bold mb-3 sm:mb-4 ${isDark ? 'text-white' : 'text-heliona-charcoal'}`} data-id="element-154">
              Support
            </h3>
            <p className={`text-base sm:text-lg leading-relaxed ${isDark ? 'text-white/70' : 'text-heliona-text-gray'}`} data-id="element-155">
              Clinical and coaching resources exactly when needed
            </p>
          </motion.div>
        </div>
      </div>
    </motion.div>;
}